import { useState } from 'react'

type Sub = { status: string; requestId?: string }

/** Запрос, ответ которого уже лежал в кеше на монтировании. Летящий — не в счёт:
 *  он ушёл недавно, и ждать следующего значило бы ждать опроса, которого может не быть. */
const staleRequestOf = (sub: Sub) => (sub.status === 'pending' ? undefined : sub.requestId)

/**
 * «Ответ получен ПОСЛЕ монтирования потребителя» — общая механика курса и статьи.
 * Ответ, лежавший в кеше на монтировании, не в счёт: ждём успешного ответа ДРУГОГО запроса.
 * Признак — `requestId`, а не время (засев кеша и свежий ответ укладываются в одну
 * миллисекунду). Однажды свежее остаётся свежим. Смена `key` — новый отсчёт.
 */
export const useFreshSince = (key: number, sub: Sub): boolean => {
  const [seen, setSeen] = useState(() => ({ key, stale: staleRequestOf(sub), fresh: false }))
  if (seen.key !== key) {
    setSeen({ key, stale: staleRequestOf(sub), fresh: false })
  } else if (!seen.fresh && sub.status === 'fulfilled' && sub.requestId !== seen.stale) {
    setSeen({ ...seen, fresh: true })
  }
  return seen.key === key && seen.fresh
}
